import React from 'react';

import {
  formatarPorcentagem,
  formatarTonelada,
  toTitleCase,
} from '../../../../helpers/formatador';
import { LoteStatus } from './styles';
import { getLoteStatusWidget } from './utils/getLoteStatusWidget';

export const getColumns = livreConcorrencia =>
  [
    {
      header: 'Transportadora',
      accessor: 'nomeTransportadora',
      format: value => toTitleCase(value),
    },
    livreConcorrencia && {
      header: 'Volume carregado',
      accessor: 'volumeCarregado',
      format: value => formatarTonelada(value),
    },
    !livreConcorrencia && {
      header: 'Saldo',
      accessor: 'saldo',
      format: value => formatarTonelada(value),
    },
    !livreConcorrencia && {
      header: 'Volume',
      accessor: 'volume',
      format: value => formatarTonelada(value),
    },
    {
      header: 'Cadência',
      accessor: 'cadencia',
      format: value => formatarTonelada(value),
    },
    {
      header: 'Aderência',
      accessor: 'percentualAderenciaDia',
      format: value => `${formatarPorcentagem(value)}`,
    },
    {
      header: 'Status',
      accessor: 'status',
      format: value => <LoteStatus>{getLoteStatusWidget(value)}</LoteStatus>,
    },
    { header: 'Previsão de embarque', accessor: 'numPrevistoCaminhoesHoje' },
  ].filter(Boolean);
